import { PRODUCT_IDS, REPORT_ATTRIBUTE_IDS } from 'constants/AppConstants';
import { ADDRESS_TYPES } from 'features/placeOrder/OrderAddresses.constants';

export const INCLUDE_SPECIAL_INSTRUCTIONS_INCOMPATIBLE_PRODUCTS = [
  PRODUCT_IDS.QuickSquaresResidential,
  PRODUCT_IDS.BidPerfect,
  PRODUCT_IDS.QuickSquaresCommercial,
  PRODUCT_IDS.Roof,
  PRODUCT_IDS.PropertyData,
];

export const WALLS_PRODUCT_TYPES = {
  Walls: 13,
  WallsLite: 29,
  WallsLiteV2: 34,
  ResWallWinDoor: 35,
  ResWallsFKALite: 36,
};

export const WALLS_PRODUCT_IDS = {
  WallsAddOn: 33,
  PremiumResidentialWallonly: 34,
  PremiumCommercialWallonly: 35,
  WallsLite: 51,
  WallsLiteAddOn: 54,
  WallsLiteV2: 78,
  WallsLiteV2AddOn: 79,
  XactwareIntegrationFeePayableWallReports: 82,
  ResWallWinDoor: 85,
  ResWallsFKALite: 86,
  ResWallWinDoorAddOn: 87,
  ResWallsFKALiteAddOn: 88,
  WallWinDoor: 107,
  WallsFKALite: 108,
};

export const WALLS_COMPATIBILITY_KEYS = {
  [WALLS_PRODUCT_TYPES.Walls]: 'IsCompatibleWithWallsAddOn',
  [WALLS_PRODUCT_TYPES.WallsLite]: 'IsCompatibleWithWallsLiteAddOn',
  [WALLS_PRODUCT_TYPES.WallsLiteV2]: 'IsCompatibleWithWallsLiteV2AddOn',
  [WALLS_PRODUCT_TYPES.ResWallWinDoor]: 'IsCompatibleWithResWallWinDoorAddOn',
  [WALLS_PRODUCT_TYPES.ResWallsFKALite]: 'IsCompatibleWitResWallsFKALiteAddOn',
};

export const WALLS_ADD_ON_IDS = {
  [WALLS_PRODUCT_TYPES.Walls]: WALLS_PRODUCT_IDS.WallsAddOn,
  [WALLS_PRODUCT_TYPES.WallsLite]: WALLS_PRODUCT_IDS.WallsLiteAddOn,
  [WALLS_PRODUCT_TYPES.WallsLiteV2]: WALLS_PRODUCT_IDS.WallsLiteV2AddOn,
  [WALLS_PRODUCT_TYPES.ResWallWinDoor]: WALLS_PRODUCT_IDS.ResWallWinDoorAddOn,
  [WALLS_PRODUCT_TYPES.ResWallsFKALite]: WALLS_PRODUCT_IDS.ResWallsFKALiteAddOn,
};

/**
 * Array of claim info fields that should not have angle brackets in them.
 * @type {string[]}
 */
export const CLAIM_INFO_FIELDS_NO_ANGLE_BRACKETS = [
  'claimNumber',
  'claimInfo',
  'PONumber',
  'catId',
  'externalReferenceId', // Job number
  'policyNumber',
];

export const SRS_INFO_RESPONSE_ATTRIBUTES = {
  accountNumber: REPORT_ATTRIBUTE_IDS.srsAccountNumber,
  shipToSequenceNumber: REPORT_ATTRIBUTE_IDS.srsShipToSequence,
  shipToName: REPORT_ATTRIBUTE_IDS.srsShipToName,
  locationCode: REPORT_ATTRIBUTE_IDS.srsLocationCode,
};

export const MAP_POINT_ADDRESS_PRIORITIES = [ADDRESS_TYPES.Verified, ADDRESS_TYPES.UserCorrected, ADDRESS_TYPES.Mapped];
